<template>
  <div class="wcim__tabBar" v-show="$route.meta.showTabBar">
    <div class="bottomfixed wcim__borT">
      <ul class="flexbox flex-alignc">
        <router-link class="flex1" active-class="on" tag="li" to="/" exact>
          <span class="ico">
            <i class="iconfont icon-tabbar_xiaoxi"></i>
            <em class="wcim__badge" v-if="unreadTotalCount > 0">{{unreadTotalCount}}</em>
          </span>
          <span class="txt">消息</span>
        </router-link>
        <router-link class="flex1" active-class="on" tag="li" to="/contact">
          <span class="ico">
            <i class="iconfont icon-tabbar_tongxunlu"></i>
          </span>
          <span class="txt">通讯录</span>
        </router-link>
        <router-link class="flex1" active-class="on" tag="li" to="/ucenter">
          <span class="ico">
            <i class="iconfont icon-tabbar_wo"></i>
          </span>
          <span class="txt">我</span>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
 computed: {
    ...mapState([]),
    ...mapGetters(["unreadTotalCount"])
  },
  data() {
    return {};
  }
};
</script>

<style>
.wcim__tabBar {
  padding-top: 1.1rem;
  position: relative;
}
.wcim__tabBar .bottomfixed {
  background: #fafafa;
  max-width: 750px;
  width: 100%;
  position: fixed;
  bottom: 0;
  z-index: 1001;
}
.wcim__tabBar ul li {
  text-align: center;
  height: 1.1rem;
}
.wcim__tabBar ul li .ico {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-top: 0.1rem;
  height: 0.5rem;
  width: 0.5rem;
  position: relative;
}
.wcim__tabBar ul li .iconfont {
  color: #9ea0a3;
  font-size: 0.45rem;
}
.wcim__tabBar ul li.on .iconfont {
  color: #41b883;
}
.wcim__tabBar ul li .txt {
  color: #7a7d81;
  display: block;
  font-size: 0.24rem;
}
.wcim__tabBar ul li.on .txt {
  color: #41b883;
}
.wcim__tabBar ul li .ico .wcim__badge {
  position: absolute;
  top: 0;
  left: 0.4rem;
}
.wcim__tabBar ul li .ico .wcim__badge-dot {
  left: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue